module.exports = __webpack_public_path__ + "img/app_logo.3229846f.png";